import { Company } from "src/app/services/response-models/companies.response.model";

export class SetUserCompany {
    static readonly type = "[APP] Set user company";

    constructor(public payload: Company) {}
}
